'use client';

import { useLocale, useTranslations } from 'next-intl';
import { Select } from '@/components/ui/Select';
import { locales, localeLabels, type Locale } from '@/i18n/config';
import { writeSigninLocaleCookie } from '@/lib/signin-locale-cookie';

/**
 * The sign-in page's own language control. It never reads the app's language:
 * the page renders in the browser's language (Accept-Language) until this
 * writes the SIGNIN_LOCALE cookie, which only signed-out pages honour. The
 * account adopts the language shown here on its first sign-in.
 */
export function SigninLanguageSelect() {
  const t = useTranslations();
  const locale = useLocale();
  return (
    <div data-testid="signin-language">
      <Select
        value={locale}
        // Options come from `locales`, so the emitted value is a Locale.
        onValueChange={(value) => {
          writeSigninLocaleCookie(value as Locale);
          window.location.reload();
        }}
        options={locales.map((l) => ({ value: l, label: localeLabels[l] }))}
        size="sm"
        ariaLabel={t('account.language')}
      />
    </div>
  );
}
